import localStorage from "redux-persist/es/storage"

export const getRoleName = roleId => {
  if (roleId == 1) {
    return "admin"
  } else if (roleId == 2) {
    return "depot"
  } else if (roleId == 3) {
    return "customer"
  } else if (roleId == 4) {
    return "sales"
  } else {
    return null
  }
}

export const getToken = async () => {
  try {
    const dataString = await localStorage.getItem("tokens");
    if (dataString) {
      const data = JSON.parse(dataString);
      return data;
    }
  } catch (e) {
    console.error("Error retrieving or parsing token data", e);
  }
  return null;
};


export const uId = () => {
  const randomKey = getRandomInt(1000000000)

  return `${randomKey}-${Date.now().toString(36)}`
}

export const getRandomInt = max => {
  return Math.floor(Math.random() * max)
}

export function formatDateString(date) {
  if (date === null || date === undefined) {
    return null;
  }
  const inputDateString = date;
  const inputDate = new Date(inputDateString);
  const year = inputDate.getFullYear();
  const month = String(inputDate.getMonth() + 1).padStart(2, "0");
  const day = String(inputDate.getDate()).padStart(2, "0");

  const formattedDateString = `${year}-${month}-${day}`;
  return formattedDateString;
}

export const formatDateTime = (dateTimeString) => {
  const dateTime = new Date(dateTimeString);

  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  };

  return dateTime.toLocaleString('en-US', options);
};

export const formatDate = (dateTimeString) => {
  const dateTime = new Date(dateTimeString);

  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };

  return dateTime.toLocaleString('en-US', options);
};

export const formatNumberWithCommas = (number) => {
  if (!number || number == 0) {
    return '₹ 0';
  } else {
    const isNegative = number < 0;
    const absoluteNumber = Math.abs(number);
    const formattedNumber = absoluteNumber.toFixed(2).toString().replace(/\./, ',');
    const user = window.localStorage.getItem('user');
    const currency = user ? JSON.parse(user).currency : '₹';
    const parts = formattedNumber.split(',');

    if (parts[0].length > 3) {
      const lastThree = parts[0].substr(parts[0].length - 3);
      const remaining = parts[0].slice(0, parts[0].length - 3);
      parts[0] = remaining.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThree;
    }

    let formattedPrice = (isNegative ? '- ' : '') + currency + ' ' + parts.join('.');

    return formattedPrice;
  }
};


export const isPermission = async (permissionName, type) => {
  const permissionsStr = await localStorage.getItem("permissions")
  const permissions = JSON.parse(permissionsStr)
  const permission = permissions.find(p => p.permission_name == permissionName)
  if (!permission)
    return false
  else
    return permission[type] == 1
}

export const getUser = async (key) => {
  const data = await localStorage.getItem("user");
  if (data) {
    const userJson = JSON.parse(data)
    return key ? userJson[key] : userJson;
  }

  return null

}

export const getPermission = async () => {
  const data = await localStorage.getItem("permissions");
  if (data) {
    const permissionJson = JSON.parse(data)
    return permissionJson;
  }

  return null

}

export const formatAmount = (amount) => {
  if (amount >= 10000000) {
    const crore = amount / 10000000;
    return '₹' + crore.toFixed(2) + " Cr";
  } else if (amount >= 100000) {
    const lakh = amount / 100000;
    return '₹' + lakh.toFixed(2) + " Lakh";
  } else if (amount >= 1000) {
    const thousand = amount / 1000;
    return '₹' + thousand.toFixed(2) + " K";
  }
  return amount.toString();
}

